(function($) {
  $(function() {

    var $slider = $('.picture-slider .slider');

    $slider.each(function(){
      var $this = $(this),
          currentSlide = 1;

      imagesLoaded($this, function(){
        var slider = $this.sudoSlider({
          continuous:true,
          responsive:true,
          auto:false,
          autoHeight:true,
          speed:500,
          prevNext:false,
          customLink:'.picture-slider .controls a',
          moveCount: 1,
          slideCount: 1,
          effect: "fadeOutIn",
          touch: true,
          mouseTouch: false,
          touchHandle: ".picture-slider img",
          initCallback: function () {
            slider.getSlide(currentSlide).addClass('active');
          },
          afterAnimation: function (t) {
            slider.find('.slide').removeClass('active');
            currentSlide = t;
            slider.getSlide(t).addClass('active');     
            slider.getSlide(t).find('.nextBtn').focus();       
          }
        });

        $(window).on('resize.sliderPause', function () { slider.stopAnimation() });

        $(window).resize();
      });
    });

  });
})($JQ);
